import { createSlice } from '@reduxjs/toolkit';

import { objectToCamelCase } from 'libs/format';
import {
  buildGenericAdapter,
  upsertEntity,
  upsertEntityWrapper,
  replaceLocalEntity,
  replaceLocalEntityWrapper,
} from 'libs/slices';

const ENTITY_NAME = 'contentSuggestion';

const contentSuggestionsAdapter = buildGenericAdapter();

const initialState = contentSuggestionsAdapter.getInitialState();

const contentSuggestionsSlice = createSlice({
  name: 'contentSuggestions',
  initialState,
  reducers: {
    addOneContentSuggestion: {
      reducer: contentSuggestionsAdapter.addOne,
      prepare: (data) => ({ payload: objectToCamelCase(data) }),
    },
    addManyContentSuggestions: {
      reducer: contentSuggestionsAdapter.addMany,
      prepare: (data) => ({ payload: data.map(objectToCamelCase) }),
    },
    updateOneContentSuggestion: {
      reducer: contentSuggestionsAdapter.updateOne,
      prepare: (data) => ({ payload: { id: data.id, changes: objectToCamelCase(data.changes) } }),
    },
    removeOneContentSuggestion: contentSuggestionsAdapter.removeOne,
    setAllContentSuggestions: {
      reducer: contentSuggestionsAdapter.setAll,
      prepare: (data) => ({ payload: data.map(objectToCamelCase) }),
    },
    upsertContentSuggestion: upsertEntityWrapper(
      upsertEntity,
      contentSuggestionsAdapter,
      ENTITY_NAME,
      objectToCamelCase,
    ),
    replaceLocalContentSuggestion: replaceLocalEntityWrapper(
      replaceLocalEntity,
      contentSuggestionsAdapter,
      ENTITY_NAME,
      objectToCamelCase,
    ),
  },
});

export const {
  addOneContentSuggestion,
  addManyContentSuggestions,
  setAllContentSuggestions,
  updateOneContentSuggestion,
  removeOneContentSuggestion,
  upsertContentSuggestion,
  replaceLocalContentSuggestion,
} = contentSuggestionsSlice.actions;

export default contentSuggestionsSlice.reducer;

export const {
  selectAll: selectAllContentSuggestions,
  selectById: selectContentSuggestionById,
  selectIds: selectContentSuggestionIds,
} = contentSuggestionsAdapter.getSelectors((state) => state.contentSuggestions);
